<template>
  <div>
    <h1 class="ma-2">
      ห้องนวด
    </h1>
    <v-container>
      <search-bar
        ref="searchBar"
        action-text="เพิ่มห้อง"
        action-icon="fas fa-plus"
        :action-persmission="userType === 'ADMIN'"
        :status="status"
        @onStatusChange="onStatusChange"
        @search="search"
        @onSearchActionButtonClick="$router.push('/admin/rooms/create')"
      />
      <v-row>
        <v-col>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    class="text-left"
                  >
                    ชื่อห้อง
                  </th>
                  <th class="text-left">
                    ประเภทห้อง
                  </th>
                  <th class="text-left">
                    สถานะ
                  </th>
                  <th class="text-left">
                    ตัวเลือก
                  </th>
                </tr>
              </thead>
              <tbody v-if="items.length > 0">
                <tr
                  v-for="item in items"
                  :key="item._id"
                >
                  <td width="40%">
                    {{ item.name }}
                  </td>
                  <td width="20%">
                    {{ item.roomType }}
                  </td>
                  <td>
                    <span :class="`${item.status === 'ACTIVE' ? 'green' : 'yellow'}--text`">
                      &#x25cf; {{ item.status === 'ACTIVE' ? 'เปิดใช้งาน' : 'ปิดใช้งาน' }}
                    </span>
                  </td>
                  <td width="20%">
                    <v-btn
                      depressed
                      icon
                      @click="$router.push(`/admin/rooms/${item._id}`)"
                    >
                      <v-icon small>
                        fas fa-edit
                      </v-icon>
                    </v-btn>
                    <v-btn
                      v-if="item.status === 'ACTIVE'"
                      depressed
                      icon
                      color="yellow"
                      @click="updateStatus(item._id, 'INACTIVE')"
                    >
                      <v-icon small>
                        fas fa-times
                      </v-icon>
                    </v-btn>
                    <v-btn
                      v-if="item.status === 'INACTIVE'"
                      depressed
                      icon
                      color="green"
                      @click="updateStatus(item._id, 'ACTIVE')"
                    >
                      <v-icon small>
                        fas fa-check
                      </v-icon>
                    </v-btn>
                    <v-btn
                      depressed
                      icon
                      @click="deleteRoom(item._id)"
                    >
                      <v-icon small>
                        fas fa-trash
                      </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td
                    colspan="6"
                    class="text-center"
                  >
                    <v-icon left>
                      far fa-dizzy
                    </v-icon>
                    ไม่พบข้อมูล
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SearchBar from '@/components/SearchBar.vue';
import http from '@/http';
import { SET_ALERT, SET_ERROR, SET_ALERT_CONTEXT } from '@/store/mutation_types';

export default {
  name: 'ServiceListView',
  components: {
    SearchBar,
  },
  data() {
    return {
      status: '',
      items: [],
    };
  },
  computed: {
    ...mapGetters(['loading', 'userType']),
  },
  watch: {
    async status(value) {
      if (value) {
        this.$refs.searchBar.onSearch();
      }
    },
  },
  async mounted() {
    this.status = 'All';
    this.componentLoading = true;
    const rooms = await http.get('/rooms');
    this.items = [...rooms.data];
    this.componentLoading = false;
  },
  methods: {
    ...mapActions([SET_ALERT, SET_ERROR, SET_ALERT_CONTEXT]),
    async updateStatus(id, status) {
      await http.put(`/rooms/${id}`, { status });
      const rooms = await http.get('/rooms');
      this.items = [...rooms.data];
      this.SET_ALERT(true);
      this.SET_ERROR(false);
      this.SET_ALERT_CONTEXT('อัพเดทสถานะห้องแล้ว');
    },
    async search(value) {
      const result = await http.get(`/rooms?name=${value.text}&status=${value.status}`);
      this.items = [...result.data];
    },
    onStatusChange(value) {
      this.status = value;
    },
    async deleteRoom(id) {
      await http.delete(`/rooms/${id}`);
      this.$refs.searchBar.onSearch();
    },
  },
};
</script>
